// types
export const SET_WALLET_CREDIT = 'SET_WALLET_CREDIT'

// actions
export const setWalletCredit = ({ wallet }) => ({
  type: SET_WALLET_CREDIT,
  wallet,
})
